import { buildProps } from '@sgui-plus/utils/props'
import type { ExtractPropTypes } from 'vue'
import type Loading from './loading.vue'

export const loadingProps = buildProps({
  backgroundColor: {
    type: String,
    default: "rgba(255,255,255,0.9)",
  },
  color: {//字体和图标颜色
    type: String,
    default: ""
  },
  size: {
    type: String,
    values: ['small', 'large', 'middle'],
    default: 'middle'
  },
  fix: {
    type: Boolean,
    default: false
  },
  // 区域加载时页面是否不可滚动
  lock: {
    type: Boolean,
    default: false
  },
  // 滚动元素
  lockTarget: {
    type: String,
    default: 'body'
  },
  // 自定义类名
  customClass: String,
  // 加载文本
  text: String,
  // 用于Loading服务使用
  visible: Boolean,
  // 用于Loading服务使用
  fullscreen: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: ''
  }
})

export type LoadingProps = ExtractPropTypes<typeof loadingProps>

export type LoadingInstance = InstanceType<typeof Loading>
